import React from 'react';

const PageNotFound = () => {
    return (
        <div className="flex items-center justify-center h-screen">
            <h1 className="font-bold text-primary text-lg">404 - Page Not Found</h1>
        </div>
    );
}

export default PageNotFound;
